import { GET_TIPO_FICHA_SUB, ADD_TIPO_FICHA_SUB, MODIFY_TIPO_FICHA_SUB, DELETE_TIPO_FICHA_SUB, UPDATE_TIPO_FICHA_SUB } from '../constants/action_types';

const initialState = {
    tipoFichaSubList: [],
    isLoading: false
};

export default function (state = initialState, action) {


    switch (action.type) {
        case GET_TIPO_FICHA_SUB:
        
            return {
                tipoFichaSubList: [],
                isLoading: true
            };

        case GET_TIPO_FICHA_SUB + "_SUCCESS":
        
            return {
                tipoFichaSubList: action.payload.data,
                isLoading: false
            };

        case ADD_TIPO_FICHA_SUB:

            const newArr = [...state.tipoFichaSubList, action.payload]
            return {
                tipoFichaSubList: newArr,
                isLoading: false
            };

        case MODIFY_TIPO_FICHA_SUB:

           return {
                tipoFichaSubList: state.tipoFichaSubList.map((p) => {
                    if (p.id !== action.payload.id) return p;
                    else return action.payload
                }),
                isLoading: false
            };
        case DELETE_TIPO_FICHA_SUB:

            return {
                tipoFichaSubList: state.tipoFichaSubList.filter(p => p.id !== action.payload.id),
                isLoading: false
            };

        case UPDATE_TIPO_FICHA_SUB + "_SUCCESS":

            return state;

        default:

            return state;
    }
}